import storage from 'proxy-storage';
import getHCStorage from '../../storage-manager/getHCStorage';
import fetchJSON from '../../../utils/fetch/fetchJSON';
import config from '../../config';
import warn from '../../../utils/warnings/warn';

/**
 * Prepare the payload to send to the updateTrafficContext API
 * @param {Object} values object of with the key and the value of the cookie or parameter to send
 * @return {Object} Structured payload to send to the API
 */
function makePayload(values) {
  const keys = Object.keys(values);
  const valuesArray = keys.map(key => ({
    Name: key,
    Value: values[key],
  }));

  return {
    TrafficContext: {
      Keys: valuesArray,
    },
  };
}

/**
 *
 * @param {Object} payload Object to save in hcStorage when the trafficContext is updated
 * @return {Object} returned payload, to be used in the frontend if is necessary
 */
function trafficContextSaved(payload) {
  const hcStorage = getHCStorage();
  hcStorage.trafficContext = payload;
  storage.setItem('hc', hcStorage);
  return payload;
}

/**
 * This function send the cookies to applicant context
 * @param {Object} provider Value of the provider of the cookie
 * @param {Object} values Object with the notation "name_of_the_cookie": "found_value"
 * @return {Promise} Promise of the call to the API
 */
function updateTrafficContext(provider, values) {
  const hcStorage = getHCStorage();
  const healthcareSession = hcStorage.healthcareSession;
  const payload = makePayload(values);
  const url = `${config.session}/${healthcareSession}`;
  return fetchJSON({ url, data: payload })
    .then(() => trafficContextSaved(payload))
    .catch((error) => {
      warn(error, {
        url,
        data: payload,
      });
    });
}

export default updateTrafficContext;
